module.exports = __webpack_public_path__ + "src/assets/img/smoke_four.38089746.svg";